export default __webpack_public_path__ + "static/media/IMG_3908 - Copy - Copy.fc234c02.jpg";